import { IconNameV1 } from 'common/icon/iconV1.js';
import { IWarning, IWarningSummary } from 'redux-state/weather-warnings/types.js';
import { IInlineWarningProps } from '../header-warning-types.js';

export type PanelHeaderConfig = Pick<IInlineWarningProps, 'label' | 'warnLevel' | 'icon' | 'url'>;

type SummaryType = {
  warnings: IWarningSummary[] | ReadonlyArray<IWarningSummary>;
  type: 'NATIONAL';
};

type WarningsType = {
  warnings: IWarning[] | ReadonlyArray<IWarning>;
  type: 'REGIONAL';
};

type FormatType = SummaryType | WarningsType;

export const buildWarningIcon = ({ icon, warnLevel }: { icon?: string; warnLevel: string }): IconNameV1 => {
  if (icon) {
    return `${icon}-${warnLevel}` as IconNameV1;
  }
  return undefined as unknown as IconNameV1;
};

/** Normalise regional and national warning data types into string that can be split into standard object used across warnings */
const normaliseLocationWarnings = (f: FormatType): PanelHeaderConfig[] => {
  if (f.type === 'REGIONAL') {
    const result = f.warnings.map((m) => {
      const { url, icon, name: label, warnLevel } = m;
      const normalisedWarn: PanelHeaderConfig = {
        label,
        url,
        icon: buildWarningIcon({ icon, warnLevel }),
        warnLevel,
      };
      return normalisedWarn;
    });
    return result;
  } else {
    /** National */
    const result = f.warnings.map((m) => {
      const { url, icon, label: label, warnLevel } = m;
      const normalisedWarn: PanelHeaderConfig = {
        label,
        url,
        icon: buildWarningIcon({ icon, warnLevel }),
        warnLevel,
      };
      return normalisedWarn;
    });
    return result;
  }
};

/** Removes any warnings that are duplicated ignore urls */
const uniqueWarningsValues = (w: PanelHeaderConfig[]): PanelHeaderConfig[] => {
  const result = w.filter((warning, index, orig) => {
    const firstMatchingIndex = orig.findIndex((t) => {
      if (t.label === warning.label && t.warnLevel === warning.warnLevel && t.icon === t.icon) {
        return true;
      }
      return false;
    });
    return index === firstMatchingIndex;
  });
  return result;
};

export const formatForLocationWarning = (f: FormatType): PanelHeaderConfig[] => {
  const normalisedWarnings = normaliseLocationWarnings(f);
  const result = uniqueWarningsValues(normalisedWarnings);
  return result;
};
